import styled from 'styled-components'

export const Container = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const PaymentElementWrapper = styled.div`
  width: 100%;
  min-height: 44px;
`

export const ErrorMessage = styled.p`
  color: #fa755a;
  margin: 0;
  font-size: 14px;
`

export const FormActions = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const InfoNote = styled.p`
  color: #6b7280;
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
`
